import { getLeaderInputs } from '../LeaderGrid/LeaderGridUtils';
import { stripHtmlStrings } from '../../../shared/stripHTMLStrings';
import { LeadershipPageData, ILeaderData } from '../LeaderPageTypes';
import { ILeaderImageCardProps } from '../../LeaderImageCard/LeaderImageCard';

export const getFeaturedLeaderInputs = (
    leader: ILeaderData,
    pageData: LeadershipPageData,
    maxGridWidth: number
): ILeaderImageCardProps => ({
    ...getLeaderInputs(leader),
    featuredCopy: stripHtmlStrings(pageData.field_landing_page_body?.value),
    image: {
        localFile:
            leader.relationships.field_hero_image?.relationships
                ?.field_media_image_1?.localFile,
        alt: leader.relationships.field_hero_image?.field_media_image_1?.alt,
    },
    maxWidth: maxGridWidth,
});
